import { Component, OnInit, Input } from '@angular/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { SelectItem, MessageService } from 'primeng/api';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStore from '../../store';
import { Store } from '@ngrx/store';
import * as fromFeature from '../../my-features';
import { updateInfoType, GateWaySnmpAuthProtocol, GateWaySnmpPrivacyProtocol, GateWayWarningProfileStr } from '../../shareModel';
import { RegionService } from 'src/app/services/region.service';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';

@Component({
  standalone: false,
  selector: 'app-snmp-profile',
  templateUrl: './snmp-profile.component.html',
  styleUrls: ['./snmp-profile.component.css']
})
export class SNMPProfileComponent implements OnInit {
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  columns_cols: any[] = [
    { field: 'vendorMib', header: TRANSLATE('Vendor MIB'), width: '150', class: 'col-nowrap ellipsis'},
    { field: 'profileName', header: TRANSLATE('Profile Name'), width: '200', class: 'col-nowrap ellipsis'},
    { field: 'company', header: TRANSLATE('Company'), width: '200', class: 'col-nowrap ellipsis'},
  ];
  snmpv3List_columns_cols: any[] = [
    { field: 'vendorMib', header: TRANSLATE('Vendor MIB'), width: '150', class: 'col-nowrap ellipsis' },
    { field: 'profileName', header: TRANSLATE('Profile Name'), width: '200', class: 'col-nowrap ellipsis' },
    { field: 'company', header: TRANSLATE('Company'), width: '200', class: 'col-nowrap ellipsis'},
    // { field: 'userName', header: TRANSLATE('User Name'), width: '150', class: 'col-nowrap ellipsis' },
    { field: 'authProtocol', header: TRANSLATE('Authentication Protocol'), width: '250', class: 'col-nowrap ellipsis'},
    // { field: 'authKey', header: TRANSLATE('Authentication Key'), width: '200', class: 'col-nowrap ellipsis' },
    { field: 'privacyProtocol', header: TRANSLATE('Privacy Protocol'), width: '200', class: 'col-nowrap ellipsis' },
    // { field: 'privacyKey', header: TRANSLATE('Privacy Key'), width: '150', class: 'col-nowrap ellipsis'},
  ];
  snmpv1List = [];
  snmpv3List = [];

  selectedsnmpv1Display: any = null;
  selectedsnmpv3Display: any = null;

  snmpv1DialogInput: {
    Id?: number;
    UpdateType: string;
    vendorMib: number;
    profileName: string;
    community: string;
    trapCommunity: string;
    company?: number;
  };

  snmpv3DialogInput: {
    Id?: number;
    UpdateType: string;
    vendorMib: number;
    profileName: string;
    userName: string;
    authProtocol: number;
    authKey: string;
    privacyProtocol: number;
    privacyKey: string;
    company?: number;
  };

  displaysnmpv1Dialog: boolean;
  displaysnmpv1DeleteDialog: boolean;
  displaysnmpv3Dialog: boolean;
  displaysnmpv3DeleteDialog: boolean;
  displaySnmpDeleteDiscoveryDialog: boolean;
  snmpv1buttonDisabled: boolean = false;
  snmpv3buttonDisabled: boolean = false;
  displayWarningDialog: boolean;
  tabSnmpv1Index = 0;
  tabSnmpv3Index = 0;
  
  vendorMIBOption = [];
  companyOptions: SelectItem[] = [];

  authenticationProtocolOption = [
    { label: 'None', value: 0 },
    { label: 'SHA1', value: 1 },
    { label: 'MD5', value: 2 },
  ];

  privacyProtocolOption = [
    { label: 'None', value: 0 },
    { label: 'AES128', value: 1 },
    { label: 'DES', value: 2 },
  ];
  gatewayMibDataDic = [];
  discoveryList = [];
  snmpv3DialogInputFlag = {
    authProtocol: false,
    authKey: false,
    privacyProtocol: false,
    privacyKey: false,
    disableSaveFlag: false
  }
  rgionDic = [];
  useGatewayList = [];		
  gatewayDic = [];		
  snmpv1GatewayList = [];	
  snmpv3GatewayList = [];	
  warningStr = '';	
  isMsp:boolean = false;	
  params: {
    otp: string;
    RegionIds?: [];
  };
  editRgionProAuthDic = [];
  constructor(
	  private store: Store<fromStore.State>,
	  private messageService: MessageService,
    private regionService: RegionService) {

    // this.ngxService.start();
    // this.store.dispatch(new fromFeature.ReadMibTrapList());

    // Get Msp
    this.store
      .select(fromStore.getIsMsp)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res) => {
        if (res !== undefined && res !== null) {
          this.isMsp = res;
          this.params = {
            otp: ''
          };
          if (res) {
            let mspRegionIdList = null;
            const mspRegionIdstr = this.regionService.GetRegionIds;
            if (mspRegionIdstr != null && mspRegionIdstr !== undefined && mspRegionIdstr.length > 0) {
              mspRegionIdList = mspRegionIdstr.split(',').map(str => parseInt(str, 10));
            }
            this.params = { ...this.params, RegionIds: mspRegionIdList };
            this.store.dispatch(new fromFeature.ReadDiscoveryInfoList({ ...this.params }));
          }
          // this.store.dispatch(new fromFeature.ReadGatewayList(this.params));
          // this.store.dispatch(new fromFeature.ReadProfileList(this.params));
        }
        if (!this.isMsp) {
          this.store.dispatch(new fromFeature.ReadDiscoveryInfoList());
        }
      });

      combineLatest(this.store.select(fromStore.getRegions), this.store.select(fromStore.getMspMemberAuthority),this.store.select(fromStore.getMspRegionFilter))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([region, mspAuth, mspFilter]) => {
        if (region !== undefined && region.length > 0 && mspAuth !== undefined && mspAuth.length > 0 && mspFilter !== null && mspFilter.selectedId !== undefined) {
          this.isMsp = mspFilter.isMsp;
          this.rgionDic = [];
          this.editRgionProAuthDic = [];
          region.map(r => {
            this.rgionDic[r.Id] = r;
          })
          this.companyOptions = [];
          this.companyOptions.push({
            label: 'Select Company', value: 0
          });
          if (this.rgionDic.length > 0) {
            mspAuth.map((m) => {
              
              if (this.editRgionProAuthDic[m.RegionId] == undefined) {
                this.editRgionProAuthDic[m.RegionId] = {};
                this.editRgionProAuthDic[m.RegionId] = m;
              }
              if (this.rgionDic[m.RegionId] !== undefined && m.EditDevice === 1 && mspFilter.selectedId !== null && mspFilter.selectedId.length > 0 && mspFilter.selectedId.includes(m.RegionId)) {
                this.companyOptions.push({
                  label: this.rgionDic[m.RegionId].RegionName,
                  value: m.RegionId
                })
              }
            })
          }
        }
      });

    combineLatest(this.store.select(fromStore.ReadProfileList), this.store.select(fromStore.ReadMibTrapList)).pipe(takeUntil(this.componentDestroyed))
    .subscribe(([profileList, mibdata] ) => {
      if (mibdata !== undefined && mibdata !== null && mibdata.length >= 0){
        this.gatewayMibDataDic = [];
        this.vendorMIBOption = [];
        this.vendorMIBOption.push({
          label: 'Please Select:', value: 0
        });
        mibdata.map((m) =>{
          this.gatewayMibDataDic[m.Id] = m;
          if (m.Type === 0) { //Mib
            this.vendorMIBOption.push({
              label: m.Name, value: m.Id
            });
          }
        })
      }
      if (profileList.Loaded && !profileList.Loading) {
        if ( profileList.entities.length >= 0) {
          this.getSnmpList(profileList.entities);
          // this.ngxService.stop();
        } else {
          this.snmpv1List = [];
          this.snmpv3List = [];
        }
      }
    })

    // Get GateWay List Dic
    this.store.select(fromStore.ReadGateWayList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        if (res.entities !== undefined && res.entities !== null && Array.isArray(res.entities) && res.entities.length > 0) {
          this.gatewayDic = [];
          res.entities.forEach((g) => {
            this.gatewayDic[g.Id] = g;
          })
        }
      }
    })

    // Get Discovery Info List
    this.store.select(fromStore.ReadProfileInfo).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null) {
        if (res.ProtocolType == 0) { // V1

          this.snmpv1DialogInput = {
            Id: res.Id,
            UpdateType: 'Edit SNMPv1',
            vendorMib: res.MibInfoId,
            profileName: res.Name,
            community: 'SNMPv1DefaultValue',
            trapCommunity: 'SNMPv1DefaultValue',
            company: res.RegionId,
          };
          this.snmpv1GatewayList = [];
          this.snmpv1GatewayList = res.GatewayList;
          this.displaysnmpv1Dialog = true;
          this.tabSnmpv1Index = 0;

        } else { // V3
          this.snmpv3DialogInput = {
            Id: res.Id,
            UpdateType: 'Edit SNMPv3',
            vendorMib: res.MibInfoId,
            profileName: res.Name,
            userName: 'SNMPv3DefaultValue',
            authProtocol: res.AuthProtocol,
            authKey: 'SNMPv3DefaultValue',
            privacyProtocol: res.PrivacyProtocol,
            privacyKey: 'SNMPv3DefaultValue',
            company: res.RegionId,
          };
          // console.log(this.snmpv3DialogInput);
          this.snmpv3GatewayList = [];
          this.snmpv3GatewayList = res.GatewayList;
          this.displaysnmpv3Dialog = true;
          this.snmpv3DialogInputFlag.disableSaveFlag = true;
          this.snmpv3DialogInputFlag.authKey = false;
          this.snmpv3DialogInputFlag.privacyKey = false;
          this.snmpv3DialogInputFlag.privacyProtocol = false;
          
          if (this.snmpv3DialogInput.authProtocol === 0) {
            this.snmpv3DialogInputFlag.authKey = true;
            this.snmpv3DialogInputFlag.privacyProtocol = true;
            this.snmpv3DialogInputFlag.privacyKey = true;
          } else if (this.snmpv3DialogInput.privacyProtocol === 0) {
            this.snmpv3DialogInputFlag.privacyKey = true;
          }
          this.tabSnmpv3Index = 0;
        }
      }
    })

    // Read Gateway Profile Info
    this.store.select(fromStore.ReadDiscoveryInfoList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if ( !res.Loading && res.Loaded && Array.isArray(res.entities) && res.entities.length > 0) {
        this.discoveryList = res.entities.map((e) => ({ ...e }));
      }
    })

    // Update Info
    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.isLoading && res.isLoaded) {
        if (res.type === updateInfoType.AddProfileInfo || res.type === updateInfoType.UpdateProfileInfo || res.type === updateInfoType.DeleteProfileInfo) {
          
          this.messageService.clear();
          if (res.isSaved) {
            this.store.dispatch(new fromFeature.ReadGatewayList({ ...this.params }));
            this.store.dispatch(new fromFeature.ReadProfileList({ ...this.params }));
            this.messageService.add({ severity: 'success', summary: TRANSLATE("Success") });
          } else {
            if (res.type === updateInfoType.AddProfileInfo || res.type === updateInfoType.UpdateProfileInfo) {
              if (res.msg !== '' && GateWayWarningProfileStr[parseInt(res.msg)] !== undefined) {
                this.warningStr = GateWayWarningProfileStr[parseInt(res.msg)];
                this.displayWarningDialog = true;
              } else {
                this.messageService.add({ severity: 'error', summary: TRANSLATE("Failed") });
              }
            } else {
              this.messageService.add({ severity: 'error', summary: TRANSLATE("Failed") });
            }
          }
          this.resetUpdateInfoState();
        }
      }
    })

  }

  ngOnInit() {
    this.initDialogInput();
    // this.ngxService.stop();
  }

  initDialogInput() {
    this.snmpv1DialogInput = {
      Id: -1,
      UpdateType: 'Add SNMPv1',
      vendorMib: 0,
      profileName: '',
      community: '',
      trapCommunity: ''
    };
    this.snmpv3DialogInput = {
      Id: -1,
      UpdateType: 'Add SNMPv3',
      vendorMib: 0,
      profileName: '',
      userName: '',
      authProtocol: 0,
      authKey: '',
      privacyProtocol: 0,
      privacyKey: '',
    };
    if (this.isMsp) {
      this.snmpv1DialogInput = {...this.snmpv1DialogInput, company: 0}
      this.snmpv3DialogInput = {...this.snmpv3DialogInput, company: 0}
    }
    this.tabSnmpv1Index = 0;
    this.tabSnmpv3Index = 0;
    
    this.displaysnmpv1Dialog = false;
    this.displaysnmpv3Dialog = false;
	}

  getSnmpList(res) {
    if (res.length > 0) {
      this.snmpv1List = [];
      this.snmpv3List = [];
      if (!this.isMsp) {
        this.columns_cols = this.columns_cols.filter(col => !(col.field === 'company'));
        this.snmpv3List_columns_cols = this.snmpv3List_columns_cols.filter(col => !(col.field === 'company'));
      }

      for (var i in res) {
        const info = res[i];
        if(info !== undefined) {
          if( this.editRgionProAuthDic[info.RegionId] !== undefined ) {
            // 沒有編輯權限的gateway只能看不能刪
            if (this.editRgionProAuthDic[info.RegionId] !== undefined) {
              if (this.editRgionProAuthDic[info.RegionId].ViewDevice === 1 && this.editRgionProAuthDic[info.RegionId].EditDevice === 0) {
                continue;
              }
            }
          }
          if (info.ProtocolType === 0) { // V1
            this.snmpv1List.push({
              id: info.Id,
              vendorMibName: this.gatewayMibDataDic[info.MibInfoId] !== undefined ? this.gatewayMibDataDic[info.MibInfoId].Name : '',
              vendorMib: info.MibInfoId,
              profileName: info.Name,
              regionId: info.RegionId,
              company: info.RegionId !== undefined && this.rgionDic.length > 0 && this.rgionDic[info.RegionId] !== undefined ? this.rgionDic[info.RegionId].RegionName : ''
  
            })
          } else if (info.ProtocolType === 1) { // V3
            this.snmpv3List.push({
              id: info.Id,
              vendorMibName: this.gatewayMibDataDic[info.MibInfoId] !== undefined ? this.gatewayMibDataDic[info.MibInfoId].Name : '',
              vendorMib: info.MibInfoId,
              profileName: info.Name,
              // userName: 'cyber snmpv3 user1',
              authProtocol: info.AuthProtocol,
              authProtocolStr: info.AuthProtocol !== 0 && GateWaySnmpAuthProtocol[info.AuthProtocol] !== undefined  ? GateWaySnmpAuthProtocol[info.AuthProtocol] : '',
              privacyProtocol: info.PrivacyProtocol,
              privacyProtocolStr: info.PrivacyProtocol !== 0 && GateWaySnmpPrivacyProtocol[info.PrivacyProtocol] !== undefined ? GateWaySnmpPrivacyProtocol[info.PrivacyProtocol] : '',
              regionId: info.RegionId,
              company: info.RegionId !== undefined && this.rgionDic.length > 0 && this.rgionDic[info.RegionId] !== undefined ? this.rgionDic[info.RegionId].RegionName : ''
            })
          }
        }
      }
      // this.ngxService.stop();
    }
  }

  showsnmpv1AddDialog() {
    this.initDialogInput();
    this.displaysnmpv1Dialog = true;
  }

  showsnmpv1EditDialog() {
    const detailParam = {
      otp: '',
      Id: this.selectedsnmpv1Display.id
    }
    this.store.dispatch(new fromFeature.ReadProfileInfo(detailParam));
	}

  checksnmpv1GatewayUsing() {

    if ( this.snmpv1GatewayList !== undefined && this.snmpv1GatewayList.length > 0) {
      this.tabSnmpv1Index = 1;
      this.useGatewayList = [];
      this.snmpv1GatewayList.map((id) => {
        this.useGatewayList.push({
          id: id,
          name: this.gatewayDic[id] !== undefined ? this.gatewayDic[id].Name : '',
          status: this.gatewayDic[id] !== undefined && this.gatewayDic[id].Status == 0 ? TRANSLATE('Normal') : TRANSLATE('Offline'),
        })
      })
    } else {
      this.tabSnmpv1Index = 0;
      this.savesnmpv1Data();
    }
  }

  checksnmpv1GatewayDiscovering() {
    this.tabSnmpv1Index = 0;
    this.displaysnmpv1Dialog = false;
    this.savesnmpv1Data();
  }

showsnmpv1DeleteDialog() {
    if (this.checkDiscovery(this.selectedsnmpv1Display.id)) {
      this.displaySnmpDeleteDiscoveryDialog = true;
    } else {
      this.displaysnmpv1DeleteDialog = true;
    }
  }

  showsnmpv3AddDialog() {
    this.initDialogInput();
    this.displaysnmpv3Dialog = true;
    this.snmpv3DialogInputFlag.disableSaveFlag = true;
    this.snmpv3DialogInputFlag.authKey = true;
    this.snmpv3DialogInputFlag.authProtocol = false;
    this.snmpv3DialogInputFlag.privacyKey = true;
    this.snmpv3DialogInputFlag.privacyProtocol = true;
  }

  showsnmpv3EditDialog() {
    const detailParam = {
      otp: '',
      Id: this.selectedsnmpv3Display.id
    }
    this.store.dispatch(new fromFeature.ReadProfileInfo(detailParam));
  }

  checksnmpv3GatewayUsing() {
    if ( this.snmpv3GatewayList !== undefined && this.snmpv3GatewayList.length > 0) {
      this.tabSnmpv3Index = 1;
      this.useGatewayList = [];
      this.snmpv3GatewayList.map((id) => {
        this.useGatewayList.push({
          id: id,
          name: this.gatewayDic[id] !== undefined ? this.gatewayDic[id].Name : '',
          status: this.gatewayDic[id] !== undefined && this.gatewayDic[id].Status === 0 ? 'Normal' : 'Offline',
        })
      })
    } else {
      this.tabSnmpv3Index = 0;
      this.savesnmpv3Data();
    }
  }

  checksnmpv3GatewayDiscovering() {
    this.tabSnmpv3Index = 0;
    this.displaysnmpv3Dialog = false;
    this.savesnmpv3Data();
  }

  showsnmpv3DeleteDialog() {
    if (this.checkDiscovery(this.selectedsnmpv3Display.id)) {
      this.displaySnmpDeleteDiscoveryDialog = true;
    } else {
      this.displaysnmpv3DeleteDialog = true;
    }
  }

  // 可能未來為需要Key入值之後,清除Value,以防錯誤
  changeInputBox(event : any = null , profileName : string = null , inputTag: string = null) {
    if (event && profileName && inputTag) {
      if (profileName === 'Edit SNMPv1') { //Snmp V1
        if (inputTag == 'community' && this.snmpv1DialogInput.community == 'SNMPv1DefaultValue') {
          this.snmpv1DialogInput.community = event.data;
        } else if (inputTag == 'trapCommunity' && this.snmpv1DialogInput.trapCommunity == 'SNMPv1DefaultValue') {
          this.snmpv1DialogInput.trapCommunity = event.data;
        }
      } else { //Snmp V3
        if (inputTag == 'userName' && this.snmpv3DialogInput.userName == 'SNMPv3DefaultValue') {
          this.snmpv3DialogInput.userName = event.data;
          this.snmpv3DialogInputFlag.disableSaveFlag = true;
        } else if (inputTag == 'authKey' && this.snmpv3DialogInput.authKey == 'SNMPv3DefaultValue') {
          this.snmpv3DialogInput.authKey = event.data;
          this.snmpv3DialogInputFlag.disableSaveFlag = true;
        } else if (inputTag == 'privacyKey' && this.snmpv3DialogInput.privacyKey == 'SNMPv3DefaultValue') {
          this.snmpv3DialogInput.privacyKey = event.data;
          this.snmpv3DialogInputFlag.disableSaveFlag = true;
        }
      }
    }
  }

  onChangeSNMPv3DailogBox() {
    this.snmpv3DialogInputFlag.disableSaveFlag = true;
    this.snmpv3DialogInputFlag.authKey = true;
    this.snmpv3DialogInputFlag.privacyProtocol = true;
    this.snmpv3DialogInputFlag.privacyKey = true;
    // 有三種情況
    // 1. authProtocol若為None則privacyProtocol必須為None,同時為None時就清空authKey與privacyKey然後disable
    // 2. authProtocol若不為None則privacyProtocol必須確認authKey是否有值才可以被選取
    // 3. privacyProtocol不為None則privacyKey必需要有值且authProtocol不能為None
    if (this.snmpv3DialogInput.authProtocol === 0 || this.snmpv3DialogInput.authProtocol === null) {
      this.snmpv3DialogInput.privacyProtocol = 0
      this.snmpv3DialogInput.privacyKey = '';
      this.snmpv3DialogInput.authKey = '';
    } else {
      this.snmpv3DialogInputFlag.authKey = false;
      this.snmpv3DialogInputFlag.privacyProtocol = false;
    }

    if (this.snmpv3DialogInput.privacyProtocol === 0 || this.snmpv3DialogInput.privacyProtocol === null) {
      this.snmpv3DialogInput.privacyKey = '';
      if (this.snmpv3DialogInput.authProtocol !== 0) {
        this.snmpv3DialogInputFlag.authKey = false;
      }
    } else {
      this.snmpv3DialogInputFlag.privacyKey = false;
    }

    // vendorMib、profileName、userName為必填,故先依此判斷是否可以save
    if ((this.snmpv3DialogInput.vendorMib !== 0 
      && this.snmpv3DialogInput.profileName !== '' 
      && this.snmpv3DialogInput.userName !== '')) {
      
      this.snmpv3DialogInputFlag.disableSaveFlag = false;
      // 若authProtocol不為None,authKey就是要必填
      if (this.snmpv3DialogInput.authProtocol !== 0 && this.snmpv3DialogInput.authProtocol !== null) {
        if (this.snmpv3DialogInput.authKey === '') {
          this.snmpv3DialogInputFlag.disableSaveFlag = true;
        }
        // 若privacyProtocol不為None,privacyKey就是要必填
        if (this.snmpv3DialogInput.privacyProtocol !== 0 && this.snmpv3DialogInput.privacyProtocol !== null) {
          if (this.snmpv3DialogInput.privacyKey === '') {
            this.snmpv3DialogInputFlag.disableSaveFlag = true;
          }
        }
      }
      if (this.isMsp && this.snmpv3DialogInput.company === 0 ) {
        this.snmpv3DialogInputFlag.disableSaveFlag = true;
      }
    }
  }

  handlesnmpv1RowSelect(event) {
    if (event.data.id === 0) {
      this.snmpv1buttonDisabled = true;
    } else {
      this.snmpv1buttonDisabled = false;
    }
  }

  handlesnmpv3RowSelect(event) {
    if (event.data.id === 0) {
      this.snmpv3buttonDisabled = true;
    } else {
      this.snmpv3buttonDisabled = false;
    }
  }

  savesnmpv1Data() {
    let param = {
      otp: '',
      MibInfoId: this.snmpv1DialogInput.vendorMib,
      ProtocolType: 0,
      Name: this.snmpv1DialogInput.profileName,
      MibCommunity: this.snmpv1DialogInput.community,
      TrapCommunity: this.snmpv1DialogInput.trapCommunity,
    } as any
    if (this.snmpv1DialogInput.UpdateType === 'Add SNMPv1') {
      if (this.isMsp && this.snmpv1DialogInput.company > 0) {
        param = {...param, RegionId: this.snmpv1DialogInput.company}
      }
      this.store.dispatch(new fromFeature.AddProfileInfo(param));
    } else {
      param = {...param, Id: this.snmpv1DialogInput.Id};
      if (this.snmpv1DialogInput.community === 'SNMPv1DefaultValue') {
        delete param.MibCommunity;
      }
      if (this.snmpv1DialogInput.trapCommunity === 'SNMPv1DefaultValue') {
        delete param.TrapCommunity;
      }
      this.store.dispatch(new fromFeature.UpdateProfileInfo(param));
    }
    this.displaysnmpv1Dialog = false;
  }

  savesnmpv3Data() {
    let param = {
      otp: '',
      MibInfoId: this.snmpv3DialogInput.vendorMib,
      ProtocolType: 1,
      Name: this.snmpv3DialogInput.profileName,
      UserName: this.snmpv3DialogInput.userName,
      AuthProtocol: this.snmpv3DialogInput.authProtocol,
      AuthKey: this.snmpv3DialogInput.authKey,
      PrivacyProtocol: this.snmpv3DialogInput.privacyProtocol,
      PrivacyKey: this.snmpv3DialogInput.privacyKey,
    } as any
    if (this.snmpv3DialogInput.UpdateType === 'Add SNMPv3') {
      if (this.isMsp && this.snmpv3DialogInput.company > 0) {
        param = {...param, RegionId: this.snmpv3DialogInput.company}
      }
      this.store.dispatch(new fromFeature.AddProfileInfo(param));
    } else {
      param = {...param, Id: this.snmpv3DialogInput.Id};
      if (this.snmpv3DialogInput.userName === 'SNMPv3DefaultValue') {
        delete param.UserName;
      }
      if (this.snmpv3DialogInput.authKey === 'SNMPv3DefaultValue') {
        delete param.AuthKey;
      }
      if (this.snmpv3DialogInput.privacyKey === 'SNMPv3DefaultValue') {
        delete param.PrivacyKey;
      }
      this.store.dispatch(new fromFeature.UpdateProfileInfo(param));
    }
    this.displaysnmpv3Dialog = false;
  }

  deletesnmpv1Data() {
    const param = {
      otp: '',
      Id: this.selectedsnmpv1Display.id
    }
    this.store.dispatch(new fromFeature.DeleteProfileInfo(param));
    this.displaysnmpv1DeleteDialog = false;
    this.selectedsnmpv1Display = null;
  }

  deletesnmpv3Data() {
    const param = {
      otp: '',
      Id: this.selectedsnmpv3Display.id
    }
    this.store.dispatch(new fromFeature.DeleteProfileInfo(param));
    this.displaysnmpv3DeleteDialog = false;
    this.selectedsnmpv3Display = null;
  }

  checkDiscovery(profileId) {
    if (this.discoveryList !== undefined && this.discoveryList.length > 0 && profileId !== undefined ) {
      for (let i = 0; i < this.discoveryList.length; i++) {
        const item = this.discoveryList[i];
        if (item.ProfileList !== undefined && item.ProfileList.length > 0) {
          const contantProfile = item.ProfileList.find(s=>s === profileId) !== undefined ? true : false;
          if (contantProfile) {
            return true
          }
        }
      }
    }
    return false
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
